import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SelectThemeComponent } from '../select-theme/select-theme.component';
import { TranslateModule } from '@ngx-translate/core';
import { MegaMenuComponent } from '../mega-menu/mega-menu.component';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { APP_CONSTANTS } from 'app/app.constants';
import { environment } from 'environments/environment';
import { AppConfigProvider } from 'app/app.config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, SelectThemeComponent, TranslateModule, MegaMenuComponent]
})
export class HeaderDesktopComponent {
  protected selectedProductIndex = -1;
  protected productList;
  protected selectedItem = '';
  protected isExternal = true;

  constructor(
    protected menuNavigationService: MenuNavigationService,
    public appConfig: AppConfigProvider,
  ) {
    this.productList = this.menuNavigationService.productList;
    this.isExternal = environment.isExternal;
  }

  public openMegamenu(index) {
    if (this.selectedProductIndex !== index) {
      this.selectedProductIndex = index;
      this.menuNavigationService.selectedProductFromMegaMenu = index;
      this.menuNavigationService.setReferencesClicked(true);
      this.selectedItem = '';
      const element = document.getElementById('table-of-content-close-button');
      if (element) {
        element.click();
      }
    } else {
      this.selectedProductIndex = -1;
    }
  }

  public closeMegamenu(event) {
    this.openMegamenu(parseInt(event, 10));
  }

  public goToHome() {
    this.selectedProductIndex = -1;
    this.selectedItem = '';
    this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.HOME);
    this.menuNavigationService.resetData();
  }

  public openTermsAndPrivacy(selectedSegment) {
    if (selectedSegment === 'privacy' && Capacitor.getPlatform() === 'web') {
      window.open(this.appConfig.privacyPolicyUrl, '_system');
    } else {
      const param = {
        calledFromSettings: true,
        selectedSegment
      };
      this.menuNavigationService.navigate(APP_CONSTANTS.ROUTE_PATHS.TERMS_CONDITION, param);
      this.menuNavigationService.resetData();
      this.menuNavigationService.updateProductList({
        selectedProductIndex: -1,
        selectedSectionIndex: -1,
      });
      this.closeMegamenu(-1);
      this.selectedItem = selectedSegment;
    }
  }
}
